import React from "react";
import { Card } from "react-bootstrap";
import { SubscriptionEstimationApi, SubscriptionEstimationFeatureTranslation } from "../../../api/types";
import SubscriptionBasedRestrictionModalPlanFeatures from "./SubscriptionBasedRestrictionModalPlanFeatures";
import SubscriptionBasedRestrictionModalPlanHeaderInfoCard from "./SubscriptionBasedRestrictionModalPlanHeaderInfoCard";
import SubscriptionBasedRestrictionModalPlanPrice from "./SubscriptionBasedRestrictionModalPlanPrice";

interface Props {
	estimatedFeature: SubscriptionEstimationApi;
	featureId: string;
	featureTranslations: SubscriptionEstimationFeatureTranslation[];
	accountsUrl: string;
	companyId: string;
}

const SubscriptionBasedRestrictionModalPlanInfoCard = ({
	estimatedFeature,
	featureId,
	featureTranslations,
	accountsUrl,
	companyId,
}: Props) => {
	return (
		<Card>
			<Card.Body>
				<SubscriptionBasedRestrictionModalPlanHeaderInfoCard />
				<SubscriptionBasedRestrictionModalPlanFeatures
					features={estimatedFeature.features}
					featureId={featureId}
					featureTranslations={featureTranslations}
				/>
				<SubscriptionBasedRestrictionModalPlanPrice
					estimatedFeature={estimatedFeature}
					accountsUrl={accountsUrl}
					companyId={companyId}
				/>
			</Card.Body>
		</Card>
	);
};

export default SubscriptionBasedRestrictionModalPlanInfoCard;
